import { useEffect } from "react";

const useGlobalScrollPrevent = prevent => {
  useEffect(() => {
    if (prevent) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => document.body.classList.remove("overflow-hidden");
  }, [prevent]);
};

export default useGlobalScrollPrevent;
